import {
  useGetCreditBalanceSummaryOption,
} from '@/service/payment/hook';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { fCurrencyUSDExtended } from '@/utils/formatNumber';
import { Coins, ExternalLink } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import PATH_PAGE from '@/router/path';
import { Skeleton } from '@/components/ui/skeleton';
import Topup from '../overview/Topup';

type Props = {
  isShowPaymentLink?: boolean;
  isShowTopupButton?: boolean;
};

const ViewCredit = ({ isShowPaymentLink, isShowTopupButton }: Props) => {
  const {
    data,
    isLoading: isLoadingCredit,
  } = useQuery({
    ...useGetCreditBalanceSummaryOption(),
  });
  const totalAvailableCredit = data?.balances?.[0]?.available_balance?.monetary?.value
    ? Number(data.balances[0].available_balance.monetary.value) / 100
    : 0;

  return (
    <Card className="w-full max-w-md">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2 text-base">
            <Coins className="h-4 w-4" />
            Credit Balance
          </CardTitle>
          {isShowPaymentLink && (
            <Link
              to={PATH_PAGE.setting.payment}
              target="_blank"
              className="flex items-center gap-1 text-xs text-muted-foreground hover:text-primary"
            >
              Go to payment <ExternalLink className="h-3 w-3" />
            </Link>
          )}
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-col gap-2">
          <span className="text-muted-foreground text-sm">Available Balance</span>
          <span className="text-2xl font-semibold text-green-600">
            {isLoadingCredit ? (
              <Skeleton className="h-8 w-24" />
            ) : (
              fCurrencyUSDExtended(totalAvailableCredit || 0)
            )}
          </span>
        </div>
        {isShowTopupButton && (
          <div className="pt-2">
            <Topup />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ViewCredit;
